import * as fromWishlist from './wishlist.reducer'
import { InjectionToken, Provider } from '@angular/core'
import { ActionReducerMap } from '@ngrx/store'
import { WishlistState } from '../../store'

export function getReducers () {
  return { defaultWishlist: fromWishlist.reducer }
}

export const reducerToken = new InjectionToken<ActionReducerMap<WishlistState>>('MbWishlistReducers')

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
}
